module.exports = __webpack_public_path__ + "img/currbooking.f68b58c8.png";